// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.KDsEBi3ibr0clE {
  display: flex;
  position: fixed;
  flex-direction: column;
  inset: 0;
}
`, ""]);
// Exports
export var container = `KDsEBi3ibr0clE`;
export default ___CSS_LOADER_EXPORT___;
